<div class="timezone-selector listbox-options">
  <div class="sticky-search-bar">
    <lx-searcher (searchTriggered)="filterTimezone($event)" [autofocus]="visible" [queryReset]="visible" data-qa="timezoneSelector_searcher"></lx-searcher>
  </div>
  <div class="listbox-options listbox-options--margin">
    <lx-list-box
      [options]="timezones$ | async"
      [(ngModel)]="selectedTimezone"
      (ngModelChange)="triggerSelectedTimezoneChanged()"
      data-qa="timezoneSelector__listbox"
    >
      <ng-template #customItemTemplate let-timezone pTemplate="item">
        {{ timezone?.name }}
      </ng-template>
    </lx-list-box>
  </div>
</div>
